import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withEnabledBlockingInitialNavigation, withHashLocation, withInMemoryScrolling, withRouterConfig, withViewTransitions } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';

import { routes } from './app.routes';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';

import localeEsPY from '@angular/common/locales/es-PY';
import { DatePipe, registerLocaleData } from '@angular/common';
import { FormatogsPipe } from './shared/pipes/formatogs.pipe';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { MesAnteriorNumericoPipe } from './modules/avancemos/core/pipes/mes-anterior-numerico.pipe';

registerLocaleData(localeEsPY, 'es-PY');

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(
            routes,
            withRouterConfig({
                onSameUrlNavigation: 'ignore'
            }),
            withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }),
            withEnabledBlockingInitialNavigation(),
            withViewTransitions(),
            withHashLocation()
        ),
        provideHttpClient(withFetch()),
        provideHttpClient(
            withInterceptors([authInterceptor]) // Registro aquí
        ),
        provideAnimationsAsync(),
        providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } } }),
        { provide: LOCALE_ID, useValue: 'es-PY' },
        provideAnimations(),
        FormatogsPipe,
        DatePipe,
        MesAnteriorNumericoPipe
    ]
};
